export class DuplicateModel {
  constructor(public order: OrderByModel[] = [], public columns: string[] = []) {}
}
export class OrderByModel {
  constructor(public field = '', public direction = 'ASC') {}
}
